import React from 'react'
import * as R from 'ramda'

import UsersPresentation from 'components/Admin/Users'
import useAxios from 'hooks/useAxios'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { AdminContainer } from 'pages/Admin'
import { Loader } from 'shared/components/Loader'
import styled from 'styled-components'
import useUser from 'hooks/useUser'

export default function Users() {
  const { data: roles } = useAxios({
    url: 'account/list-role/',
  })

  const { data: users } = useAxios({
    url: 'account/accounts/?limit=300',
  })
  const userMe = useUser()

  if (!users || !userMe || !roles) {
    return (
      <React.Fragment>
        <PageHeaderContainer title="Users" />
        <AdminContainer>
          <Container>
            <Loader withContainer />
          </Container>
        </AdminContainer>
      </React.Fragment>
    )
  } else {
    const accounts = R.prop('results')(users) || []
    return (
      <UsersPresentation
        accounts={accounts}
        usedSeatCount={users.used_seat_count}
        roles={roles}
        userMe={userMe}
      />
    )
  }
}

const Container = styled.div`
  width: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Users/index.js